import { getAccessToken } from '../authentication/supabaseService';
import type { SetupReviewPayload, SetupReviewDecision, SetupReviewDecisionResult, SetupReviewBulkRemoval, SetupReviewBulkRemovalResult } from './inventorySetupReviewTypes';

export class SetupReviewError extends Error {
  constructor(public readonly code: string, public readonly status: number) {
    super(code);
  }
}

async function request<T>(restaurantId: string, suffix: string, decision?: SetupReviewDecision | SetupReviewBulkRemoval): Promise<T> {
  const token = await getAccessToken();
  const response = await fetch(`/api/inventory/setup-review/${encodeURIComponent(restaurantId)}${suffix}`, {
    method: decision ? 'POST' : 'GET',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    ...(decision ? { body: JSON.stringify(decision) } : {}),
  });
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new SetupReviewError(body.error || 'request_failed', response.status);
  }
  return response.json();
}

export const fetchInventorySetupReview = (restaurantId: string, groupId: string) =>
  request<SetupReviewPayload>(restaurantId, `?groupId=${encodeURIComponent(groupId)}`);

export const saveInventorySetupDecision = (restaurantId: string, decision: SetupReviewDecision) =>
  request<SetupReviewDecisionResult>(restaurantId, '/decision', decision);

export const removeInventorySetupReviewProducts = (restaurantId: string, input: SetupReviewBulkRemoval) =>
  request<SetupReviewBulkRemovalResult>(restaurantId, '/remove-review-products', input);
